// src/services/library/author.ts
import { AUTHOR } from "../../utils/constants";
import { get, post, put } from "../../utils/axios-config";
import { AuthorType } from "../../types/Library";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";

export const createAuthor = async (data: AuthorType) => await post(AUTHOR, data);

export const updateAuthor = async (data: AuthorType) => await put(AUTHOR, data);

export const getAuthors = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || "1",
        PageSize: data?.PageSize?.toString() || "10",
    });
    const url = `${AUTHOR}?${queryParams.toString()}`;
    return await get<PagedResultsType<AuthorType>>(url);
};
